import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var FolderLock = function FolderLock(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m13 7-1.1155-2.231c-.3211-.6422-.4816-.9633-.7211-1.1978a2 2 0 0 0-.7473-.4619C10.0992 3 9.7402 3 9.0223 3H5.2c-1.1201 0-1.6802 0-2.108.218a2 2 0 0 0-.874.874C2 4.5198 2 5.08 2 6.2V7m0 0h15.2c1.6802 0 2.5202 0 3.162.327a3 3 0 0 1 1.311 1.311C22 9.2798 22 10.1198 22 11.8v4.4c0 1.6802 0 2.5202-.327 3.162a3 3 0 0 1-1.311 1.311C19.7202 21 18.8802 21 17.2 21H6.8c-1.6802 0-2.5202 0-3.162-.327a3 3 0 0 1-1.311-1.311C2 18.7202 2 17.8802 2 16.2zm8.1 10.5h3.8c.5601 0 .8401 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.2139.109-.4939.109-1.054v-.8c0-.5601 0-.8401-.109-1.054a1 1 0 0 0-.437-.437c-.2139-.109-.4939-.109-1.054-.109h-3.8c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437c-.109.2139-.109.4939-.109 1.054v.8c0 .5601 0 .8401.109 1.054a1 1 0 0 0 .437.437c.214.109.494.109 1.054.109m3.65-4v-1.75c0-.9665-.7835-1.75-1.75-1.75s-1.75.7835-1.75 1.75v1.75z"
    })
  }));
};
export default FolderLock;